export default __webpack_public_path__ + "static/media/property_384.93128bd1.png";